import { useEffect } from 'react';
import { DateTime } from 'luxon';

export const usePaymentCycleRefresh = (
  enabled: boolean,
  timezone: string,
  refetch: () => unknown
): void => {
  useEffect(() => {
    if (!enabled) return;
    let timer: ReturnType<typeof setTimeout>;
    const scheduleMidnight = () => {
      const now = DateTime.now().setZone(timezone);
      if (!now.isValid) return;
      timer = setTimeout(() => {
        refetch();
        scheduleMidnight();
      }, now.plus({ days: 1 }).startOf('day').diff(now).as('milliseconds') + 50);
    };
    const refresh = () => {
      refetch();
    };
    scheduleMidnight();
    window.addEventListener('focus', refresh);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('focus', refresh);
    };
  }, [enabled, timezone, refetch]);
};
